<template>
  <td class="hm-table-button" v-on="$listeners">
    <i :class="`icon far fa-${icon}`"></i>
  </td>
</template>

<script>
export default {
  name: 'HMTableButton',
  props: {
    icon: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-table-button {
  width: 20px;
  color: $medium-gray;
  vertical-align: middle;
  cursor: pointer;
  &:hover {
    color: var(--brand-color, $coral);
  }
}
.icon {
  padding: 0 0.25rem;
}
</style>
